import getAllAgreements from '../../api/Agreement/getAllAgreements.api';
import moveLeadToPurchaser from '../../api/Agreement/moveLeadToPurchaser.api';
import getAllPurchasers from '../../api/Purchasers/getAllPurchasers.api';
import getAuditTrailInformation from '../../api/Purchasers/getAuditTrailInformation.api';
import getCoolingPeriodTime from '../../api/Purchasers/getCoolingPeriodTime.api';
import getDocumentStatusByDocumentName from '../../api/Purchasers/getDocumentStatus.api';
import getPurchaserById from '../../api/Purchasers/getPurchaserById.api';
import firebase from '../../lib/firebase.prod';
import {
	CONVERT_LEAD_FAIL,
	CONVERT_LEAD_SUCCESS,
	GET_ALL_AGREEMENTS_SUCCESS,
	GET_AUDIT_TRAIL_FAIL,
	GET_AUDIT_TRAIL_SUCCESS,
	GET_COOLING_FAIL,
	GET_COOLING_SUCCESS,
	GET_DOC_TARGET_FAIL,
	GET_DOC_TARGET_SUCCESS,
	GET_PURCHASERS_FAIL,
	GET_PURCHASERS_SUCCESS,
	GET_PURCHASER_BY_ID_FAIL,
	GET_PURCHASER_BY_ID_SUCCESS,
	SET_LOADING_FAIL,
	SET_LOADING_SUCCESS,
} from './types';

export const getPurchasers = () => {
	return async (dispatch, getState) => {
		console.log('wfdnsoifsjfio');
		var state = getState();
		var userType = state.signIn.userType;
		console.log(' wfdnsoifsjfio userType', userType);
		try {
			console.log(' wfdnsoifsjfio fail');
			getAllPurchasers(userType, (returned) => {
				console.log('getPurchasers returned', returned);
				dispatch(getPurchasersSuccess(returned));
			});
		} catch (error) {
			getPurchasersFail(error);
		}
	};
};

export const getPurchaserByLeadId = (salesAgentId, id) => {
	return async (dispatch) => {
		try {
			getPurchaserById(salesAgentId, id).then((returned) =>
				dispatch(getPurchaserByIdSuccess(returned))
			);
		} catch (error) {
			dispatch(getPurchaserByIdFail(error));
		}
	};
};

export const getAgreementstList = () => {
	return async (dispatch) => {
		try {
			getAllAgreements((returned) => {
				dispatch(getAllAgreementsSuccess(returned));
			});
		} catch (error) {
			dispatch(getAllAgreementsFail(error));
		}
	};
};

export const convertLeadToPurchaser = (leadId) => {
	return async (dispatch, getState) => {
		var state = getState();
		try {
			moveLeadToPurchaser(leadId, state.signIn.userType);

			dispatch(convertLeadSuccess('success'));
		} catch (error) {
			dispatch(convertLeadFail(error));
		}
	};
};

export const getAuditTrail = (leadId, documentName) => {
	return async (dispatch) => {
		try {
			var data = getAuditTrailInformation(leadId, documentName);

			dispatch(getAuditTrailSuccess(data));
		} catch (error) {
			dispatch(getAuditTrailFail(error));
		}
	};
};

export const getCoolingPeriodStart = (leadId) => {
	return async (dispatch) => {
		try {
			getCoolingPeriodTime(leadId, (returned) => {
				console.log('getCoolingPeriodStart returned', returned);
				dispatch(getCoolingPeriodSuccess(returned));
			});
		} catch (error) {
			console.log('getCoolingPeriodStart herre');
			dispatch(getCoolingPeriodFail(error));
		}
	};
};

export const resetCoolingPeriodStart = () => {
	return async (dispatch) => {
		try {
			dispatch(getCoolingPeriodFail());
		} catch (error) {
			dispatch(getCoolingPeriodFail(error));
		}
	};
};

export const setDocumentTarget = (documentTarget) => {
	return async (dispatch) => {
		try {
			dispatch(getDocumentTargetSuccess(documentTarget));
		} catch (error) {
			dispatch(getDocumentTargetFail(error));
		}
	};
};

export const setLoading = (payload) => {
	return async (dispatch) => {
		try {
			dispatch(setLoadingSuccess(payload));
		} catch (error) {
			dispatch(setLoadingFail(error));
		}
	};
};

export const setLoadingSuccess = (payload) => ({
	type: SET_LOADING_SUCCESS,
	payload,
});
export const setLoadingFail = (payload) => ({
	type: SET_LOADING_FAIL,
	payload,
});

const getDocumentTargetSuccess = (payload) => ({
	type: GET_DOC_TARGET_SUCCESS,
	payload,
});

const getDocumentTargetFail = (payload) => ({
	type: GET_DOC_TARGET_FAIL,
	payload,
});

const getCoolingPeriodSuccess = (payload) => ({
	type: GET_COOLING_SUCCESS,
	payload,
});

const getCoolingPeriodFail = (payload) => ({
	type: GET_COOLING_FAIL,
	payload,
});

const getAuditTrailSuccess = (payload) => ({
	type: GET_AUDIT_TRAIL_SUCCESS,
	payload,
});

const getAuditTrailFail = (payload) => ({
	type: GET_AUDIT_TRAIL_FAIL,
	payload,
});

const getPurchasersSuccess = (payload) => ({
	type: GET_PURCHASERS_SUCCESS,
	payload,
});

const getPurchasersFail = (payload) => ({
	type: GET_PURCHASERS_FAIL,
	payload,
});

const getPurchaserByIdSuccess = (payload) => ({
	type: GET_PURCHASER_BY_ID_SUCCESS,
	payload,
});

const getPurchaserByIdFail = (payload) => ({
	type: GET_PURCHASER_BY_ID_FAIL,
	payload,
});

const getAllAgreementsSuccess = (payload) => ({
	type: GET_ALL_AGREEMENTS_SUCCESS,
	payload,
});

const getAllAgreementsFail = (payload) => ({
	type: GET_ALL_AGREEMENTS_SUCCESS,
	payload,
});

const convertLeadSuccess = (payload) => ({
	type: CONVERT_LEAD_SUCCESS,
	payload,
});

const convertLeadFail = (payload) => ({
	type: CONVERT_LEAD_FAIL,
	payload,
});
